<template>
  <div class="not-found-container">
    <h1 class="title">!! 查无此货!!</h1>
    <div class="divider"></div>
    <div class="error-warning">
      <span class="error">错误 ×</span>
      <span class="warning">警告 ⚠️ !!</span>
    </div>
    <!-- <p class="tip">您访问的商品不存在，可能已被下架或链接有误。</p> -->
    <div class="actions">
      <button @click="goBack">返回上一页</button>
      <button @click="goHome">返回首页</button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goBack = () => {
  router.go(-1) || router.push('/')
}

const goHome = () => {
  router.push('/')
}
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.divider {
  width: 80px;
  height: 2px;
  background: #e74c3c;
  margin: 20px 0;
  border-radius: 1px;
}

.error-warning {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  font-size: 1.5rem;
  text-align: center;
}

.error {
  color: #e74c3c;
  font-weight: bold;
}

.warning {
  color: #f39c12;
  font-weight: bold;
}

.tip {
  margin-top: 24px;
  color: #666;
  max-width: 400px;
  text-align: center;
  line-height: 1.6;
}

.actions {
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.actions button {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.actions button:first-child {
  background: #ecf0f1;
  color: #2c3e50;
}

.actions button:first-child:hover {
  background: #bdc3c7;
}

.actions button:last-child {
  background: #3498db;
  color: white;
}

.actions button:last-child:hover {
  background: #2980b9;
}
</style>